import { adjustmentService } from '@/services';
import { hubDailyReportApiEndPointMapper } from '@/constants/hubAdjustment/daily';
import HubAdjustmentDailyReportVM from '@/view-model/hub-adjustment/HubAdjustmentDailyReportVM';
import { hubSelectorGetterType } from '@/vuex-store/hub-selector/getters';
import { hubDailyReportMutationList, hubDailyReportActionTypeList, } from './types';
const actions = {
    [hubDailyReportActionTypeList.setReportType]({ commit }, type) {
        commit(hubDailyReportMutationList.SET_REPORT_TYPE, type);
    },
    [hubDailyReportActionTypeList.setDetailDate]({ commit }, date) {
        commit(hubDailyReportMutationList.SET_DETAIL_DATE, date);
    },
    [hubDailyReportActionTypeList.setFilterOption]({ commit }, payload = {}) {
        commit(hubDailyReportMutationList.SET_FILTER_OPTION, payload);
    },
    [hubDailyReportActionTypeList.resetFilterOptions]({ commit }) {
        commit(hubDailyReportMutationList.RESET_FILTER_OPTIONS);
    },
    [hubDailyReportActionTypeList.setKeyword]({ commit }, keyword) {
        commit(hubDailyReportMutationList.SET_KEYWORD, keyword);
    },
    [hubDailyReportActionTypeList.setSearchType]({ commit, }, type) {
        commit(hubDailyReportMutationList.SET_SEARCH_TYPE, type);
    },
    async [hubDailyReportActionTypeList.getHubDailyReport]({ state, getters, commit, rootGetters, }) {
        const type = state.reportType;
        if (!type) {
            return false;
        }
        const hubId = rootGetters[hubSelectorGetterType.getterSubscribeHubId];
        if (!hubId) {
            return false;
        }
        try {
            const typeEndpoint = hubDailyReportApiEndPointMapper[type];
            const storeType = getters.getterStoreType;
            const { keyword, orderMetricsDailyConditionType, } = state;
            // 조회 기간(정산일) 'yyyy-MM-dd'
            let { fromAt, toAt, } = state.filterOption;
            const isDetailPage = !!state.detailDate;
            // 조회 기간(정산일) 'yyyyMMdd'
            fromAt = isDetailPage ? state.detailDate : fromAt.replaceAll('-', '');
            toAt = isDetailPage ? state.detailDate : toAt.replaceAll('-', '');
            const response = await adjustmentService
                .getHubAdjustmentReportByType(hubId, typeEndpoint, fromAt, toAt, storeType, keyword, orderMetricsDailyConditionType);
            commit(hubDailyReportMutationList.GET_HUB_DAILY_REPORT, {
                report: new HubAdjustmentDailyReportVM(response.data),
                type,
            });
            return true;
        }
        catch (error) {
            console.log('[hubAdjustment/main/getHubDailyReport]', error);
            const message = error.response?.data.error.message ?? error.message;
            commit(hubDailyReportMutationList.RESET_HUB_DAILY_REPORT);
            return {
                message,
            };
        }
    },
    [hubDailyReportActionTypeList.resetHubDailyReport]({ commit }) {
        commit(hubDailyReportMutationList.RESET_HUB_DAILY_REPORT);
    },
};
export default actions;
